function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  background: linear-gradient(135deg, \n    var(--vscode-editor-background, #f5f5f5) 0%, \n    var(--vscode-sideBar-background, #fafafa) 100%\n  );\n  border: 1px solid var(--vscode-editorWidget-border, var(--theme-border));\n  border-radius: var(--theme-radius-md, 8px);\n  padding: var(--theme-spacing-lg, 24px);\n  margin: var(--theme-spacing-lg, 24px) 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  margin: 0 0 var(--theme-spacing-md, 16px) 0;\n  font-size: var(--theme-typography-font-size-lg, 1.125rem);\n  font-weight: var(--theme-typography-font-weight-semibold, 600);\n  color: var(--vscode-editor-foreground, var(--theme-text));\n  display: flex;\n  align-items: center;\n  gap: var(--theme-spacing-sm, 8px);\n  \n  svg {\n    color: var(--vscode-textLink-foreground, var(--theme-primary));\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  margin-bottom: var(--theme-spacing-lg, 24px);\n  \n  &:last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  margin: 0 0 var(--theme-spacing-sm, 8px) 0;\n  font-size: var(--theme-typography-font-size-base, 1rem);\n  font-weight: var(--theme-typography-font-weight-medium, 500);\n  color: var(--vscode-editor-foreground, var(--theme-text));\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  padding-left: var(--theme-spacing-lg, 24px);\n  \n  li {\n    margin-bottom: var(--theme-spacing-xs, 4px);\n    color: var(--vscode-editor-foreground, var(--theme-text));\n    font-size: var(--vscode-font-size, var(--theme-typography-font-size-sm, 0.875rem));\n    line-height: 1.6;\n    \n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: var(--theme-spacing-sm, 8px);\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  background: var(--vscode-editor-selectionBackground, rgba(33, 150, 243, 0.1));\n  border-left: 3px solid var(--vscode-textLink-foreground, var(--theme-primary));\n  padding: var(--theme-spacing-sm, 8px) var(--theme-spacing-md, 16px);\n  border-radius: 0 var(--theme-radius-sm, 4px) var(--theme-radius-sm, 4px) 0;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  font-weight: var(--theme-typography-font-weight-semibold, 600);\n  color: var(--vscode-editor-foreground, var(--theme-text));\n  font-size: var(--vscode-font-size, var(--theme-typography-font-size-sm, 0.875rem));\n  margin-bottom: 2px;\n  display: flex;\n  align-items: center;\n  gap: var(--theme-spacing-xs, 4px);\n  \n  svg {\n    color: var(--vscode-textLink-foreground, var(--theme-primary));\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  color: var(--vscode-descriptionForeground, var(--theme-text-secondary));\n  font-size: var(--theme-typography-font-size-xs, 0.8125rem);\n  line-height: 1.5;\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { BookOpen } from 'lucide-react';
import { Hash } from 'lucide-react';
var Container = styled.div(_templateObject());
var Title = styled.h3(_templateObject1());
var Section = styled.div(_templateObject2());
var SectionTitle = styled.h4(_templateObject3());
var PointsList = styled.ul(_templateObject4());
var KeyTermsContainer = styled.div(_templateObject5());
var KeyTerm = styled.div(_templateObject6());
var TermName = styled.div(_templateObject7());
var TermDefinition = styled.div(_templateObject8());
var SummaryCard = function(param) {
    var title = param.title, points = param.points, keyTerms = param.keyTerms;
    return /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Title, null, /*#__PURE__*/ React.createElement(BookOpen, {
        size: 20
    }), title), /*#__PURE__*/ React.createElement(Section, null, /*#__PURE__*/ React.createElement(SectionTitle, null, "핵심 내용"), /*#__PURE__*/ React.createElement(PointsList, null, points.map(function(point, index) {
        return /*#__PURE__*/ React.createElement("li", {
            key: index
        }, point);
    }))), keyTerms && keyTerms.length > 0 && /*#__PURE__*/ React.createElement(Section, null, /*#__PURE__*/ React.createElement(SectionTitle, null, "주요 용어"), /*#__PURE__*/ React.createElement(KeyTermsContainer, null, keyTerms.map(function(term, index) {
        return /*#__PURE__*/ React.createElement(KeyTerm, {
            key: index
        }, /*#__PURE__*/ React.createElement(TermName, null, /*#__PURE__*/ React.createElement(Hash, {
            size: 14
        }), term.term), /*#__PURE__*/ React.createElement(TermDefinition, null, term.definition));
    }))));
};
// Default export for backward compatibility
export default SummaryCard;
